import { useContext } from 'react';
import { userContext } from '../components/auth/auth.context';

export default function useAuth() {
  return useContext(userContext);
}
